import { createSlice } from "@reduxjs/toolkit";
import {
    getAllClientProject,
    getAllProjectManagers, addClient, addProjectManager, addProject
    , getByIdClient, getAllClientsWithProjects
} from "src/thunks/clientProjects";

const initState = {
    loading: false,
    getByIdLoadingState: false,
    addNewClientLoading: false,
    addProjectLoading: false,
    clientProject: [],
    individualClientInfo: [],
    projectManagersList: [],
    allProjectData: [],
    allClientsWithProjects: [],
};

const ClientProjects = createSlice({
    name: "clientProjects",
    initialState: initState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder

                /** Retrieve all clients with projects data -------------------------**/
                .addCase(getAllClientProject.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getAllClientProject.fulfilled, (state, action) => {
                    state.loading = false;
                    state.clientProject = action.payload;
                })
                .addCase(getAllClientProject.rejected, (state, action) => {

                })

                /** Retrieve all clients with projects data -------------------------**/
                .addCase(getAllClientsWithProjects.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getAllClientsWithProjects.fulfilled, (state, action) => {
                    state.loading = false;
                    state.allClientsWithProjects = action.payload;
                })
                .addCase(getAllClientsWithProjects.rejected, (state, action) => {
                    state.loading = false;
                })

                /** Retrieve all project managers data -------------------- **/
                .addCase(getAllProjectManagers.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getAllProjectManagers.fulfilled, (state, action) => {
                    state.loading = false;
                    state.projectManagersList = action.payload;
                })
                .addCase(getAllProjectManagers.rejected, (state, action) => {
                })

                /** Add new client -------------------------- **/
                .addCase(addClient.pending, (state, action) => {
                    state.addNewClientLoading = true;
                })
                .addCase(addClient.fulfilled, (state, action) => {
                    state.addNewClientLoading = false;
                    // state.projectManagersList = action.payload;
                })
                .addCase(addClient.rejected, (state, action) => {
                    state.addNewClientLoading = false
                })

                /** Add new project manager ---------------------- **/
                .addCase(addProjectManager.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(addProjectManager.fulfilled, (state, action) => {
                    state.loading = false;
                    state.projectManagersList = action.payload;
                })
                .addCase(addProjectManager.rejected, (state, action) => {
                    state.loading = false;
                })

                /** Add new project ------------------------------- **/
                .addCase(addProject.pending, (state, action) => {
                    state.addProjectLoading = true;
                })
                .addCase(addProject.fulfilled, (state, action) => {
                    state.addProjectLoading = false;
                    // state.allProjectData = action.payload;
                })
                .addCase(addProject.rejected, (state, action) => {
                    state.addProjectLoading = false;
                })

                /** Get individual client data by id ---------------------- **/
                .addCase(getByIdClient.pending, (state, action) => {
                    state.getByIdLoadingState = true;
                })
                .addCase(getByIdClient.fulfilled, (state, action) => {
                    state.getByIdLoadingState = false;
                    state.individualClientInfo = action.payload;
                })
                .addCase(getByIdClient.rejected, (state, action) => {
                    state.getByIdLoadingState = false;
                })
        },

});

export default ClientProjects;